import React, { useState, useEffect } from "react";
import styled from "styled-components";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import MuiTableHead from "@mui/material/TableHead";
import Collapse from "@mui/material/Collapse";
import { Tab } from "common/layouts/Tabs";
import TableBody from "@mui/material/TableBody";

const Wrapper = styled.div`
  display: flex;
  align-items: top;
  justify-content: ${({ numeric }) => (numeric ? "flex-end" : "flex-start")};
  width: 100%;
  cursor: pointer;
`;

const IconWrapper = styled.div`
  font-size: 18px;
  line-height: 18px !important;
  .material-icons {
    color: var(--icon-primary) !important;
    font-size: 18px;
    line-height: 18px !important;
  }
`;

function ExpandableCell({ value, columns, collapsed, numeric }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(!collapsed);
  }, [collapsed]);

  return (
    <TableCell colSpan={columns?.length}>
      <Wrapper onClick={() => setOpen(!open)} numeric={numeric}>
        <div>
          {value && value.length > 1 ? `${value.length} entries` : "1 entry"}
        </div>
        <IconWrapper>
          <i className="material-icons">
            {open ? "expand_less" : "expand_more"}
          </i>
        </IconWrapper>
      </Wrapper>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Table>
          <TableBody>
            {value.map((row, index) => {
              return (
                <TableRow key={`row${index}`}>
                  {Object.values(row).map((rowItem, index) => {
                    const { numeric, renderCell } = columns[index];
                    return (
                      <TableCell
                        align={numeric ? "right" : "left"}
                        width={`${100 / columns?.length}%`}
                        key={`row${index}column${index}`}
                      >
                        {renderCell ? renderCell(rowItem) : rowItem}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Collapse>
    </TableCell>
  );
}

export default ExpandableCell;
